// *** TEXT SERVICE ***

// *** CAPITALIZE FIRST LETTER IN STRING ***
export const capitalizeFirstLetter = input => {
    if (!input.length) return input;
    return `${input.charAt(0).toUpperCase()}${input.slice(1)}`;
};
